import { css } from 'styled-components'
import { rem } from 'polished'
import zIndex from 'styles/tools/z-index'

export const packageSelectionMobileFooterStyles = css`
  position: fixed;
  z-index: ${zIndex.stickyFooter};
  inset-inline: 0;
  bottom: 0;
  display: grid;
  gap: ${rem(8)};
  padding: ${rem(20)} ${rem(16)};
  padding-bottom: calc(${rem(20)} + env(safe-area-inset-bottom));
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  box-shadow: ${props => props.theme.shadow.top.small};
  border: 0;
  border-radius: 0;
  margin: 0;
  &.empty { display: none; }
`

export const packageSelectionCartButtonStyles = css`
  && {
    width: ${rem(32)};
    min-width: ${rem(32)};
    height: ${rem(32)};
    border-radius: ${rem(100)};
    padding: 0;
    flex: none;
    justify-content: center;
  }
`
